<template>
  <div class="thumbnails">
    <label class="thumbnails__label">{{ label }}</label>
    <div :id="galleryID" class="thumbnails__items">
      <a
        v-for="(item, key) in value"
        :key="key"
        :href="item.url"
        :data-pswp-width="$path('dimensions.0', item)"
        :data-pswp-height="$path('dimensions.1', item)"
        target="_blank"
        rel="noreferrer"
      >
        <img class="thumbnails__item" :src="item.url" :alt="item.name" />
      </a>
    </div>
  </div>
</template>

<script>
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js'
import 'photoswipe/dist/photoswipe.css'

export default {
  props: {
    galleryID: {
      type: String,
      default: `photoswipe-${Math.random().toString(36).slice(2, 9)}`,
    },
    value: Array,
  },

  mounted() {
    if (!this.lightbox) {
      this.lightbox = new PhotoSwipeLightbox({
        gallery: '#' + this.galleryID,
        children: 'a',
        pswpModule: () => import('photoswipe'),
      })
      this.lightbox.init()
    }
  },
  unmounted() {
    if (this.lightbox) {
      this.lightbox.destroy()
      this.lightbox = null
    }
  },
}
</script>

<style lang="scss">
.thumbnails {
  --thumbnail-size: 3rem;

  &__label {
    display: block;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }

  &__items {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
  }

  &__item {
    width: var(--thumbnail-size);
    height: var(--thumbnail-size);
    object-fit: cover;
    object-position: center;
    border-radius: var(--border-radius, 3px);
    cursor: pointer;
  }
}
</style>
